import { IGameState } from 'State/Game/IGameState';
import Game from 'Game';
import { FBTrackingEvent } from 'Utility/Tracking/FBTrackingEvent';
import DateHelper from 'Utility/DateHelper';

/**
 * Attempt to track a mission start event to Facebook analytics. This function will update the `missionAttempts` property
 * of `state.playerState` and compare against the timestamp `state.playerState.missionAttemptsStartTimestamp`. If the attempt
 * occurs within 24 hours of the start-timestamp increment the attempts and send tracking events if applicable. This tracking
 * data is used exclusively to train UA algorithms.
 * @param state
 */
export function trackLevelStart(state: IGameState) {
    // Validate timestamp is initialized. This should be initialized by the data manager as a default value. However, it
    // could be cleared by cheating.
    if (
        state.playerState.missionAttemptsStartTimestamp === undefined ||
        state.playerState.missionAttemptsStartTimestamp === null
    ) {
        state = {
            ...state,
            playerState: {
                ...state.playerState,
                missionAttemptsStartTimestamp: DateHelper.now,
            },
        };
    }

    // Validate user is within first 24 hours.
    if (DateHelper.isCompleted(state.playerState.missionAttemptsStartTimestamp, DateHelper.daysToMilliseconds(1))) {
        return state;
    }

    // Increment mission attempts.
    state = {
        ...state,
        playerState: {
            ...state.playerState,
            missionAttempts: state.playerState.missionAttempts + 1,
        },
    };

    // Send tracking events if applicable:
    if (state.playerState.missionAttempts === 10) {
        Game.sdk.gameTracking(FBTrackingEvent.LevelStartsIn24Hours10);
    } else if (state.playerState.missionAttempts === 20) {
        Game.sdk.gameTracking(FBTrackingEvent.LevelStartsIn24Hours20);
    } else if (state.playerState.missionAttempts === 30) {
        Game.sdk.gameTracking(FBTrackingEvent.LevelStartsIn24Hours30);
    } else if (state.playerState.missionAttempts === 40) {
        Game.sdk.gameTracking(FBTrackingEvent.LevelStartsIn24Hours40);
    }

    return state;
}
